import axios from 'axios'
import { ElMessage } from 'element-plus'
import { useUserStore } from '../stores/user'

const request = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:3000/api',
  timeout: 10000
})

const AUTH_PUBLIC_PATHS = [
  '/auth/login',
  '/auth/register',
  '/auth/register-shop',
  '/auth/register-shop/preview',
  '/auth/reset-password'
]

function isPublicAuthRequest(config) {
  const url = String(config?.url || '')
  return AUTH_PUBLIC_PATHS.some((p) => url.includes(p))
}

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    const userStore = useUserStore()
    // 登录/注册/找回密码不带旧 token，避免干扰
    if (userStore.token && !isPublicAuthRequest(config)) {
      config.headers.Authorization = `Bearer ${userStore.token}`
    }
    // FormData 交给浏览器自动带 multipart boundary
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      if (config.headers) {
        delete config.headers['Content-Type']
        delete config.headers['content-type']
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    const { code, message, data } = response.data

    if (code === 200) {
      return data
    } else {
      ElMessage.error(message || '请求失败')
      return Promise.reject(new Error(message))
    }
  },
  (error) => {
    const { response, config } = error
    const msg = response?.data?.message || '网络错误'
    const status = response?.status || 0

    if (status === 401) {
      if (isPublicAuthRequest(config)) {
        ElMessage.error(msg)
        const err = new Error(msg)
        err.status = status
        return Promise.reject(err)
      }
      const userStore = useUserStore()
      userStore.logout()
      ElMessage.error('登录已过期，请重新登录')
      if (!window.location.hash.includes('/login')) {
        window.location.href = '/#/login'
      }
      const err = new Error(msg)
      err.status = status
      return Promise.reject(err)
    }

    if (status === 402) {
      ElMessage.warning(msg || '店铺使用期已到期，请续费')
      if (!window.location.hash.includes('/shop-features')) {
        window.location.href = '/#/shop-features'
      }
      const err = new Error(msg)
      err.status = status
      err.subscription = response?.data?.data
      return Promise.reject(err)
    }

    ElMessage.error(msg)
    const err = new Error(msg)
    err.status = status
    return Promise.reject(err)
  }
)

export default request
